module.exports = __webpack_public_path__ + "img/wikipedia.b7d97b6b.png";